export default __webpack_public_path__ + "static/media/other.d3f6135a.svg";